<template>
    <div :class="[{ 'o-popups-container--click-transparent': hasCameraUpdatedRecently }, 'o-popups-container']">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LabelsContainer',
    inject:['mapViewer'],
    props:{
        height: {type:String, default:'100vh'},
    },
    data(){
        return{
            hasCameraUpdatedRecently: false,
            cameraUpdateTimeout: null,
            cameraUpdateTimeoutDelay: 500,
            containerWidth: null,
            containerHeight: null,

        }
    },
    methods:{
        handleCameraUpdate() {
            clearTimeout(this.cameraUpdateTimeout);
            this.hasCameraUpdatedRecently = true;
            this.cameraUpdateTimeout = setTimeout(() => {
                this.hasCameraUpdatedRecently = false
            }, this.cameraUpdateTimeoutDelay)
        },
        handleWindowResize(event) {
            this.$nextTick( () => {
                this.mapViewer.$data.containerWidth = event.currentTarget.innerWidth;
                this.mapViewer.$data.containerHeight = event.currentTarget.innerHeight;
            });
        },

    },
    updated(){
    },
    mounted(){
        this.$bus.$on('map:ready', () => {
            setTimeout(() => {
                this.mapViewer.viewApi.register_event('on_camera_update', this.handleCameraUpdate);
                window.addEventListener('resize', this.handleWindowResize);
                this.mapViewer.$data.containerWidth = this.$el.innerWidth;
                this.mapViewer.$data.containerHeight = this.$el.innerHeight;
            },1000);
        });
    },
    beforeDestroy(){
        this.mapViewer.viewApi.deregister_event('on_camera_update', this.handleCameraUpdate);
        window.removeEventListener('resize', this. handleWindowResize)

    }
}
</script>

<style lang="scss">
  .o-popups-container{
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &--click-transparent{
      .m-unit-info{
        pointer-events: none;
        cursor: default;
      }
    }
  }
</style>
